module.exports = __webpack_public_path__ + "static/plumpton-college-campus-d8dae61d611c8c26b4080e184405d1d8.jpg";